import { useEffect, useRef, type ReactNode } from 'react';
import { X } from 'lucide-react';

export function Modal({ titulo, aberto, aoFechar, children, classe }: { titulo: string; aberto: boolean; aoFechar: () => void; children: ReactNode; classe?: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (aberto && !d.open) d.showModal();
    if (!aberto && d.open) d.close();
  }, [aberto]);
  return (
    <dialog ref={ref} className={classe ? `modal ${classe}` : 'modal'} onClose={aoFechar} onCancel={aoFechar}>
      <header>
        <h2>{titulo}</h2>
        <button type="button" className="btn-icone" onClick={aoFechar} aria-label="Fechar"><X size={20} strokeWidth={1.7} /></button>
      </header>
      {aberto && children}
    </dialog>
  );
}
